import { CATEGORIES } from "@/lib/constants";

const CATEGORY_ORDER = CATEGORIES.map((c) => c.key);

const pill = (on) => `px-2.5 py-1 rounded-full text-[11px] border transition-colors ${on ? "bg-amber-500 text-onaccent border-amber-500" : "border-line text-slate-400 hover:text-amber-200"}`;
const toggle = (list, v) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);

export const ScopePicker = ({ value, onChange, pages, allowEntries = true }) => {
  const s = { all: false, categories: [], page_ids: [], ...value };
  return (
    <div className="space-y-2" data-testid="scope-picker">
      <div className="flex flex-wrap gap-1.5">
        <button type="button" className={pill(s.all)} onClick={() => onChange({ ...s, all: !s.all })} data-testid="scope-all">Whole wiki</button>
        {!s.all && CATEGORY_ORDER.map((c) => (
          <button key={c} type="button" className={pill(s.categories.includes(c))} onClick={() => onChange({ ...s, categories: toggle(s.categories, c) })} data-testid={`scope-cat-${c}`}>{c}</button>
        ))}
      </div>
      {!s.all && allowEntries && (
        <select value="" onChange={(e) => e.target.value && onChange({ ...s, page_ids: toggle(s.page_ids, e.target.value) })}
          className="w-full h-8 rounded-md bg-inset border border-line text-xs text-slate-300 px-2" data-testid="scope-entry-select">
          <option value="">+ Add a single entry…</option>
          {pages.filter((p) => !s.categories.includes(p.category)).map((p) => <option key={p.id} value={p.id}>{s.page_ids.includes(p.id) ? "✓ " : ""}{p.title} ({p.category})</option>)}
        </select>
      )}
      {!s.all && s.page_ids.length > 0 && (
        <div className="flex flex-wrap gap-1.5">{s.page_ids.map((id) => (
          <button key={id} type="button" onClick={() => onChange({ ...s, page_ids: toggle(s.page_ids, id) })} className="text-[11px] rounded-full border border-amber-500/30 px-2 py-0.5 text-amber-200" data-testid={`scope-entry-${id}`}>{pages.find((p) => p.id === id)?.title || "entry"} ×</button>
        ))}</div>
      )}
    </div>
  );
};
